module.exports = __webpack_public_path__ + "1702a0.png";